// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"76":"552c917b","490":"552c917b","565":"aabf9f2b","748":"a4e4f19e"}[chunkId] + ".chunk.css";
};